import { useEffect, useState } from "react";
import api from "../lib/api";
import { PROJECTS as FALLBACK_PROJECTS } from "../data/content";

export function mapProject(p) {
  return {
    ...p,
    img: p.image_url || p.img,
  };
}

export function useProjects() {
  const [projects, setProjects] = useState(FALLBACK_PROJECTS.map(mapProject));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/projects")
      .then((r) => {
        if (!cancelled && Array.isArray(r.data) && r.data.length > 0) {
          setProjects(r.data.map(mapProject));
        }
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { projects, loading };
}

export function useProjectsAdmin(reloadKey = 0) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    api
      .get("/projects?all=true")
      .then((r) => setProjects(r.data.map(mapProject)))
      .catch((err) => {
        setProjects([]);
        setError(err?.response?.status === 404 ? "projects_api_missing" : "load_failed");
      })
      .finally(() => setLoading(false));
  }, [reloadKey]);

  return { projects, loading, error };
}
